import {
  FormattedNamesDTO,
} from '@/dtos';

export type NameFormatKey = keyof FormattedNamesDTO;

export const displayNameKey = 'indexByLastNameWithCredentials' as const satisfies NameFormatKey;
export const initialsKey = 'initials' as const satisfies NameFormatKey;
